import { ActionType, createReducer } from 'typesafe-actions';
import { clearVisitors, setVisitors, removeVisitor } from 'store/visitors-emails/actions';

import { VisitorsEmailsState } from './types';

export const initialState: VisitorsEmailsState = {};

const setVisitorsHandler = (
  _state: VisitorsEmailsState,
  { payload }: ActionType<typeof setVisitors>,
): VisitorsEmailsState => {
  return payload;
};

const clearVisitorsHandler = (): VisitorsEmailsState => initialState;

const removeVisitorHandler = (
  state: VisitorsEmailsState,
  { payload }: ActionType<typeof removeVisitor>,
): VisitorsEmailsState => {
  const { [payload]: removed, ...remainingVisitors } = state;

  // Reorder the remaining visitors to have consecutive keys
  const reorderedVisitors: VisitorsEmailsState = {};
  Object.keys(remainingVisitors)
    .map(Number)
    .sort((a, b) => a - b)
    .forEach((oldKey, index) => {
      const newKey = index + 1;
      reorderedVisitors[newKey] = remainingVisitors[oldKey];
    });

  return reorderedVisitors;
};

const visitorsEmailsReducer = createReducer(initialState)
  .handleAction(setVisitors, setVisitorsHandler)
  .handleAction(clearVisitors, clearVisitorsHandler)
  .handleAction(removeVisitor, removeVisitorHandler);

export default visitorsEmailsReducer;
